import { Link, useNavigate } from 'react-router-dom';
import api from "../../services/api";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Card, CardContent, Typography, Button, Snackbar, Alert, Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Save as IconSave } from "@mui/icons-material";
import { PaperComponentDraggable } from "../common/PaperComponentDraggable";
import PersonaNatural from './PersonaNatural'
import PersonDirection from './PersonDirection'
import PersonDocument from './PersonDocument'
import PersonContact from './PersonContact'
import PersonBonding from './PersonBonding'
import { activeValidationsPersonaNatural, initPerson } from "../../redux/person/personSlice";
import { activeValidationsPersonaDocumento } from "../../redux/person/personDocumentSlice";
import { setPersonaDirecciones } from '../../redux/person/personDirectionSlice';
import { setPersonaVinculaciones } from '../../redux/person/personBondingSlice';
import { setPersonaContactos } from '../../redux/person/personContactSlice';
import { setPersonaDocumentos } from '../../redux/person/personDocumentSlice';
import { setPersonaAntecedentes } from '../../redux/person/personPastSlice';
import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";
import { notifySuccess, notifyWarning, notifyError } from "../../services/notificationService";
import { usePersonNaturalForm } from "../../hooks/person/usePersonNaturalForm"
import PersonNaturalFormBody from "./PersonNaturalFormBody"
import PageHeader from "../common/PageHeader"
import SaveButtonBar from "../common/SaveButtonBar"

const PersonRegister = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dialogRef = useRef();
    const sliceKey = props.sliceKey;
    const initialized = useRef(false);

    useEffect(() => {
        if (props.open && !initialized.current) {
            dispatch(initPerson({ sliceKey: sliceKey }));
            initialized.current = true;
        }
        if (!props.open) {
            initialized.current = false;
        }
    }, [props.open, dispatch, sliceKey]);

    const {
        idNew,
        savePerson
    } = usePersonNaturalForm(sliceKey, {
        useBonding: false
    });

    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"md"}
            ref={dialogRef}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle
                id="draggable-dialog-title"
                style={{ cursor: "move" }}>
                <PageHeader
                    title={(props.id == 0 ? "Nueva" : "Editar") + " Persona Natural"}
                />
            </DialogTitle>
            <DialogContent style={{ minHeight: "350px", maxHeight: "400px" }}>
                <div>
                    <PersonNaturalFormBody
                        sliceKey={sliceKey}
                        id={props.id}
                        hideInputs={props.hideInputs}
                        showBonding={false}
                    />
                </div>
            </DialogContent>
            <DialogActions sx={{
                justifyContent: "center",
                gap: 2,
                pb: 2
            }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                        const result = await savePerson();

                        if (!result) {
                            return; // validation/API error: keep dialog open
                        }

                        props.setNewPersonSaved(
                            result
                        );

                        props.openClose(); // close only after success
                    }}
                >
                    Aceptar
                </Button>
                <Button variant="outlined" onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default PersonRegister;
